'use client';
import React, {useState, useContext, useEffect} from 'react'
import { Input, } from '@nextui-org/react'
import CardDefault from '../cards/CardDefault';
import { UserContext } from '../../../contexts/UserContext';
import { useRouter, useSearchParams } from 'next/navigation';

import { COUNTRY_UAE_ID, isDev } from '../../../data/constants';
import { Route } from '../../../routers/routes';
import InputDefault from '../forms/InputDefault';
import ButtonWSpinner from '../buttons/ButtonWSpinner';
import Link from 'next/link';
import { translateIt } from '@/data/translations';


export default function LoginForm(props) {
  const { 
    onSuccess = null,  
    countryId = COUNTRY_UAE_ID,
  } = props

  const { push } = useRouter()
  const searchParams = useSearchParams()

  let formDataPayload = {}  
  if (isDev) {
    formDataPayload = {
      username: 'FinanceMan',
      password: 'MystikaL!2k12',
    } 
  }
  const [formData, setFormData] = useState(formDataPayload)

  const [errors, setErrors] = useState({})
  const [isLoading, setIsLoading] = useState(false)
  const {initiateAuthentication, me, isAuthenticated} = useContext(UserContext)

  const handleOnChange = e => {
    setFormData({...formData, [e.target.name]: e.target.value})
  }
  const handleOnFormSubmit = async (e) => {
    e.preventDefault()
    setIsLoading(true)
    setErrors({})
    const {success, errors } = await initiateAuthentication(formData)
    if(success) {
      handleRedirect()
    }
    setErrors(errors)
    setIsLoading(false)
    
  }

  const handleRedirect = () => {
    if(searchParams.get('next')){
      const url = searchParams.get('next')
      push(url)
      return
    } else {
      if(onSuccess) {
        onSuccess()
      } else {
        const url = Route.loginRedirect()
        push(url)
      }
    }
  }
  

  useEffect(() => {

  }, [me, isAuthenticated])

  const renderErrors = () => {
    if (Object.keys(errors).length === 0) {
      return null
    }
    return (
      <div className="mt-4 bg-danger p-4">
        <ul>
        {Object.keys(errors).map((key) => {
          return (
            <li key={key}>{key}: {errors[key]}</li>
          )
        })}
        </ul>
      </div>
    )
  }

  return (
    <>
      <CardDefault className="w-full">
        <div>
          <p className="mb-4">{translateIt(countryId, 'login__enterLoginCredentials')}</p>
          <form onSubmit={handleOnFormSubmit}>
            <InputDefault 
              name="username" type="username" 
              label={translateIt(countryId, 'login__username')} 
              placeholder={translateIt(countryId, 'login__enterYourUsername')} 
              formData={formData} errors={errors}
              onChange={handleOnChange}
            />
            <Input 
              name="password" type="password" 
              label={translateIt(countryId, 'login__password')} 
              placeholder={translateIt(countryId, 'login__enterYourPassword')} 
              formData={formData} errors={errors}
              onChange={handleOnChange}
            />
            <ButtonWSpinner
              onClick={handleOnFormSubmit} 
              type="submit"
              className="w-full mt-4" color="secondary"
              label={translateIt(countryId, 'login__login')}
              isLoading={isLoading}
            />
            {renderErrors()}
          </form>
          <p className="mt-4">
            {/* {translateIt(countryId, 'login_dontHaveAnAccount')} 
            <Link href={Route.signup()} className="ml-2 underline">
              {translateIt(countryId, 'login_createANewAccount')} 
            </Link> */}
          </p>
        </div>
      </CardDefault>
    </>
  )
}
